// Public historical allowlist, reconciled read-only against immutable pilot grades.
// Deliberately contains no current pilot boards, raw records or account data.
const MATCHES=Object.freeze([
 {date:'2026-10-12',session:'evening',strategy:'traveling',number:'508',type:'Fireball Straight',main:'598',fireball:'0'},
 {date:'2026-10-12',session:'evening',strategy:'repeat_pair',number:'509',type:'Fireball Box',main:'598',fireball:'0'},
 {date:'2026-10-13',session:'midday',strategy:'grid',number:'286',type:'Box',main:'268',fireball:'4'},
 {date:'2026-10-13',session:'midday',strategy:'grid',number:'246',type:'Fireball Box',main:'268',fireball:'4'},
 {date:'2026-10-13',session:'midday',strategy:'14_day_challenge',number:'628',type:'Box',main:'268',fireball:'4'},
 {date:'2026-10-13',session:'midday',strategy:'todays_top_numbers',number:'286',type:'Box',main:'268',fireball:'4'},
 {date:'2026-10-13',session:'evening',strategy:'grid',number:'808',type:'Straight',main:'808',fireball:'9'}
].map(r=>Object.freeze({...r,scope:'PILOT RESULT'})));
module.exports={MATCHES};
